import React from "react";
import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import Registrants from "../Registrants";
import styles from "./styles.module.scss";

interface RegistrantsModalProps {
  isOpen: boolean;
  onClose: () => void;
  programModel: any;
  userType: string;
  onRegistrationSuccess: (response: any) => void;
  onRegistrantDeleted: (response: any) => void;
  title: string;
  onTransferComplete?: () => void;
}

const RegistrantsModal: React.FC<RegistrantsModalProps> = ({
  isOpen,
  onClose,
  programModel,
  userType,
  onRegistrationSuccess,
  onRegistrantDeleted,
  title,
  onTransferComplete,
}) => {
  return (
    <ModalLayout isOpen={isOpen} classNames={styles.modal} onClose={onClose}>
      <button
        type="button"
        className={styles.close_button}
        onClick={onClose}
        aria-label="Close"
      >
        <i className="ico ico-x" />
      </button>
      <h1>{title}</h1>
      <div className={styles.body}>
        <Registrants
          programModel={programModel}
          userType={userType}
          onRegistrationSuccess={onRegistrationSuccess}
          onRegistrantDeleted={onRegistrantDeleted}
          showRegistrantsWaitlisted={true}
          onTransferComplete={onTransferComplete}
        />
      </div>
    </ModalLayout>
  );
};

export default RegistrantsModal;
